var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09411 2.1667C6.09411 2.05895 6.13691 1.95562 6.2131 1.87944C6.28928 1.80325 6.39261 1.76045 6.50036 1.76045C6.6081 1.76045 6.71143 1.80325 6.78762 1.87944C6.86381 1.95562 6.90661 2.05895 6.90661 2.1667L6.90661 7.17711H9.75036C9.83065 7.17719 9.90913 7.20105 9.97587 7.24569C10.0426 7.29034 10.0946 7.35376 10.1253 7.42795C10.1561 7.50214 10.1641 7.58376 10.1485 7.66252C10.1328 7.74128 10.0942 7.81363 10.0374 7.87045L6.78744 11.1204C6.71127 11.1965 6.60801 11.2393 6.50036 11.2393C6.3927 11.2393 6.28945 11.1965 6.21327 11.1204L2.96327 7.87045C2.90653 7.81363 2.8679 7.74128 2.85225 7.66252C2.83661 7.58376 2.84465 7.50214 2.87537 7.42795C2.90609 7.35376 2.9581 7.29034 3.02484 7.24569C3.09159 7.20105 3.17006 7.17719 3.25036 7.17711H6.09411V2.1667Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownActive);
export default __webpack_public_path__ + "static/media/down-active.825e585431e3d2fa6439bf4982f2b09a.svg";
export { ForwardRef as ReactComponent };